import React, { useContext, useEffect, useRef, useState } from 'react'
import FinalMolGrid from '../../../components/FinalMolGrid/FinalMolGrid'
import { BoardCommitteApprovalListConfig } from '../data/BoardCommitteApprovalListConfig';
import { useParams } from 'react-router-dom';
import { decryptAESID } from '../../../utils/Encryption';
import { useLazyGetAllBoardCommitteeApprovalListQuery, useLazyResendSendBoardCommitteeApprovalMailQuery } from '../../../app/services/BoardCommitteeApproval/BoardCommitteeServiceApi';
import SwalAlert from '../../../services/swalService/SwalService';
import MembershipTaskListContext from '../MembershipTaskListContextProvider';

const BoardCommitteeList = () => {
    const params = useParams();
    const molGridRef = useRef()
    const { success, confirm } = SwalAlert();
    const { taskListDetailsData, boardCommitteeListData, fetchBoardCommitteeList, isBoardCommitteeListLoading, } = useContext(MembershipTaskListContext);

    const [resendSendBoardCommitteeApprovalMail, {
        isLoading: resendSendBoardCommitteeApprovalMailIsLoading,
        data: resendSendBoardCommitteeApprovalMailData,
        isSuccess: resendSendBoardCommitteeApprovalMailSuccess
    }] = useLazyResendSendBoardCommitteeApprovalMailQuery();

    useEffect(() => {
        if (!resendSendBoardCommitteeApprovalMailIsLoading && resendSendBoardCommitteeApprovalMailData && resendSendBoardCommitteeApprovalMailSuccess) {
            if (resendSendBoardCommitteeApprovalMailData.boardCommitteeApprovalId > 0) {
                success("Email Resend Successfully.");
            }
        }
    }, [resendSendBoardCommitteeApprovalMailIsLoading, resendSendBoardCommitteeApprovalMailData, resendSendBoardCommitteeApprovalMailSuccess]);

    useEffect(() => {
        if (params) {
            let request = {
                ipasMemberId: Number(decryptAESID(params.memberId)),
                taskListId: Number(decryptAESID(params.taskListId)),
            }
            fetchBoardCommitteeList(request)
        }
    }, [params]);

    const handleResendClick = (rowData, index) => {
        if (taskListDetailsData?.applicationStatusId === 10) {
            return;
        }
        else if (taskListDetailsData?.isBoardCommitteeSubmittedByAdmin) {
            return; // if alrady submitted then not allow OR Rejected
        }
        else {
            const { boardCommitteeApprovalId, name } = rowData;
            confirm('Confirm Resend', `Are you sure you want to resend approval request to: ${name}`, 'Yes', 'NO').then((res) => {
                if (!res)
                    return;
                let request = {
                    boardCommitteeApprovalId: boardCommitteeApprovalId,
                }
                resendSendBoardCommitteeApprovalMail(request);
            })
        }
    }

    const actionHandler = {
        RESEND: handleResendClick,
    }

    return (
        <div className='table-100'>
            <FinalMolGrid
                ref={molGridRef}
                configuration={BoardCommitteApprovalListConfig}
                dataSource={boardCommitteeListData}
                isLoading={isBoardCommitteeListLoading}
                allowPagination={false}
                onActionChange={actionHandler}
            />
        </div>
    )
}

export default BoardCommitteeList
